const Conditional = ({
  condition,
  renderIf,
  renderElse = null
}) => {
  return condition ? renderIf : renderElse;
};
export {
  Conditional
};
//# sourceMappingURL=index.es.js.map
